import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import './App.css';

function App() {
  const [activeSection, setActiveSection] = useState('home');
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [galleryOpen, setGalleryOpen] = useState(false);
  const [contactFormOpen, setContactFormOpen] = useState(false);

  const aboutImages = [
    { src: '/images/img5.jpeg', alt: 'GSC INDIA Farms' },
    { src: '/images/img2.jpeg', alt: 'Sheep Farming' },
    { src: '/images/img7.jpeg', alt: 'Research Center' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % aboutImages.length);
    }, 3000); // Change image every 3 seconds
    
    return () => clearInterval(interval);
  }, [aboutImages.length]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setActiveSection(sectionId);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const openGallery = (index) => {
    setCurrentImageIndex(index);
    setGalleryOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeGallery = () => {
    setGalleryOpen(false);
    document.body.style.overflow = 'unset';
  };

  const navigateImage = (direction) => {
    if (direction === 'next') {
      setCurrentImageIndex((prev) => (prev + 1) % aboutImages.length);
    } else {
      setCurrentImageIndex((prev) => (prev - 1 + aboutImages.length) % aboutImages.length);
    }
  };

  const handleKeyDown = (e) => {
    if (!galleryOpen) return;
    if (e.key === 'Escape') closeGallery();
    if (e.key === 'ArrowRight') navigateImage('next');
    if (e.key === 'ArrowLeft') navigateImage('prev');
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [galleryOpen]);

  const openContactForm = () => {
    setContactFormOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeContactForm = () => {
    setContactFormOpen(false);
    document.body.style.overflow = 'unset';
  };

  const handleContactSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the form data to a server
    alert('Thank you for contacting us! We will get back to you soon.');
    closeContactForm();
  };

  return (
    <div className="App">
      {/* Navigation */}
      <Navbar activeSection={activeSection} onContactClick={openContactForm} />

      {/* Main Content */}
      <div className="main-content">
        {/* Home Section */}
        <section id="home" className="section home-section">
          <h1 className="section-title">Welcome to GSC INDIA Farms and Research Center</h1>
          <div className="home-content">
            <div className="home-text">
              <p className="section-content">
                Welcome to GSC INDIA Farms and Research Center, where tradition meets technology to create a new standard in organized farming and livestock excellence. We are proud to welcome you to a platform built on quality, research, and innovation, dedicated to delivering healthy livestock and premium farm-fresh meat you can trust.
              </p>
              <p className="section-content" style={{ marginTop: '1rem' }}>
                At GSC INDIA Farms and Research Center, every process is guided by science and integrity. From elevated hygienic sheds and advanced health care practices to balanced nutrition and in-house feed research, we ensure the highest standards of animal welfare and productivity.
              </p>
            </div>
            <div className="home-image">
              <img src="/images/WhatsApp Image 2026-01-26 at 2.02.01 PM.jpeg" alt="GSC INDIA Farms" className="main-image" />
            </div>
          </div>
          
          <div className="feature-grid">
            <div className="feature-card">
              <div className="feature-image">
                <img src="/images/img2.jpeg" alt="Quality Assurance" className="feature-img" />
              </div>
              <h3 className="feature-title">Quality Assurance</h3>
              <p className="feature-description">
                Strict protocols ensure ethical handling and premium quality in all our products and services.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-image">
                <img src="/images/img3.jpeg" alt="Research Driven" className="feature-img" />
              </div>
              <h3 className="feature-title">Research Driven</h3>
              <p className="feature-description">
                Our Research Center continuously works on improving feed formulations and farming methods.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-image">
                <img src="/images/img4.jpeg" alt="Sustainable Farming" className="feature-img" />
              </div>
              <h3 className="feature-title">Sustainable Farming</h3>
              <p className="feature-description">
                Committed to responsible practices that lead to better outcomes for animals and consumers.
              </p>
            </div>
          </div>
        </section>

        {/* About Us Preview Section */}
        <section id="about" className="section">
          <h2 className="section-title">About Us</h2>
          <div className="about-content">
            <div className="about-text">
              <p style={{ marginTop: '0.5rem' }}>
                GSC INDIA Farms and Research Center stands as a progressive example of how traditional livestock practices can be transformed through vision, organization, and technology. Founded by B. Chakravarthy, the organization was established with a clear mission: to bring structure, transparency, and modern systems into the largely unorganized farming and meat production sector in India.
              </p>
              <p style={{ marginTop: '0.5rem' }}>
                From the outset, B. Chakravarthy envisioned a model where farming is treated not merely as a livelihood, but as a professionally managed enterprise. His goal was to organize every stage of the value chain from breeding and feed management to livestock rearing, processing, distribution, and retail under a single, technology-driven framework.
              </p>
              <div style={{ textAlign: 'center', marginTop: '2rem' }}>
                <Link to="/about" className="read-more-btn">
                  Read More
                </Link>
              </div>
            </div>
            <div className="about-image-stack">
              {aboutImages.map((image, index) => (
                <img 
                  key={index}
                  src={image.src} 
                  alt={image.alt} 
                  className={`about-stack-img ${index === currentImageIndex ? 'active' : ''}`}
                  onClick={() => openGallery(index)}
                  style={{ cursor: 'pointer' }}
                />
              ))}
            </div>
          </div>
        </section>

        {/* What We Do Section */}
        <section id="services" className="section">
          <h2 className="section-title">What We Do</h2>
          <div className="services-content">
            <div className="services-text">
              <p>
                Sheep farming plays a vital role in meeting the growing demand for quality mutton, and at GSC INDIA Farms and Research Center, this process is driven by a strong focus on hygiene, health care, balanced nutrition, and well-designed infrastructure. One of the most important infrastructure practices followed is the use of elevated sheds, which significantly improve animal health and growth performance.
              </p>
              <p style={{ marginTop: '1rem' }}>
                <strong>Hygiene is the foundation</strong> of efficient sheep farming at GSC INDIA Farms and Research Center. Clean, well-ventilated elevated sheds keep animals away from damp ground, mud, and waste accumulation. This design improves airflow, keeps the floor dry, and reduces bacterial growth. Regular cleaning, proper drainage beneath the sheds, and dry bedding help control parasites and infections.
              </p>
              <p style={{ marginTop: '1rem' }}>
                <strong>Elevated sheds play a major role</strong> in improving animal health at GSC INDIA Farms and Research Center. By preventing direct contact with soil and moisture, these sheds reduce the risk of foot rot, skin infections, internal parasites, and respiratory problems. Lambs remain comfortable and stress-free, especially during monsoon seasons, which directly supports immunity and consistent growth.
              </p>
              <p style={{ marginTop: '1rem' }}>
                <strong>Health care management</strong> is another key focus at GSC INDIA Farms and Research Center. Routine vaccination, timely deworming, and parasite control are carried out systematically. Continuous health monitoring allows early detection of diseases, reducing mortality and treatment costs.
              </p>
              <p style={{ marginTop: '1rem' }}>
                <strong>A balanced feed program</strong> supports rapid lamb fattening and premium meat production at GSC INDIA Farms and Research Center. Scientifically formulated rations rich in energy, protein, vitamins, and minerals promote muscle development and uniform growth.
              </p>
            </div>
            <div className="services-gallery">
              <div className="gallery-grid">
                <img src="/images/img6.jpeg" alt="Sheep Farming" className="gallery-img" />
                <img src="/images/img7.jpeg" alt="Elevated Sheds" className="gallery-img" />
                <img src="/images/img8.jpeg" alt="Health Care" className="gallery-img" />
                <img src="/images/img9.jpeg" alt="Feed Program" className="gallery-img" />
              </div>
            </div>
          </div>
        </section>

        {/* Feed Formulation Section */}
        <section id="feed" className="section">
          <h2 className="section-title">Feed Formulation</h2>
          <div className="feed-content">
            <div className="feed-text">
              <p>
                GSC INDIA Farms and Research Center has established a strong foundation in livestock nutrition through its own dedicated feed research and development program, designed to support faster growth, better animal health, and superior meat quality. Recognizing that feed accounts for the largest share of farming costs and directly impacts productivity, GSC INDIA Farms places nutrition at the core of its operations.
              </p>
              <p style={{ marginTop: '1rem' }}>
                <strong>The Feed Research division</strong> at GSC INDIA Farms and Research Center focuses on developing scientifically balanced rations tailored to different growth stages of sheep and lambs. Each formulation is carefully designed to provide the right balance of energy, protein, fiber, vitamins, and minerals required for efficient weight gain and strong immunity.
              </p>
              <p style={{ marginTop: '1rem' }}>
                <strong>High-quality raw material sourcing</strong> from across India is another key strength. Ingredients such as grains, oil cakes, mineral mixtures, and natural supplements are procured from trusted regions known for their quality and consistency. Every input is selected after strict quality checks to ensure purity, nutritional value, and safety.
              </p>
              <p style={{ marginTop: '1rem' }}>
                <strong>Continuous testing and refinement</strong> of formulations based on on-ground performance data ensures that feed is not only nutritionally rich but also palatable and easily digestible. This reduces wastage, improves intake, and supports steady daily weight gain.
              </p>
            </div>
            <div className="feed-images">
              <img src="/images/img10.jpeg" alt="Feed Research" className="feed-img" />
              <img src="/images/img11.jpeg" alt="Feed Formulation" className="feed-img" />
              <img src="/images/img12.jpeg" alt="Quality Testing" className="feed-img" />
            </div>
          </div>
        </section>

        {/* Contact Us Section */}
        <section id="contact" className="section contact-section">
          <h2 className="section-title">Contact Us</h2>
          <div className="contact-grid">
            <div className="contact-item">
              <div className="contact-icon">
                <i className="fas fa-building"></i>
              </div>
              <h3 className="contact-title">Corporate Office</h3>
              <p className="contact-details">
                4TH FLOOR PLOT NO 63 AMAR SOCIETY<br />
                KAVURI HILLS MADHAPUR<br />
                HYDERABAD-500081<br />
                TELANGANA, INDIA
              </p>
            </div>
            <div className="contact-item">
              <div className="contact-icon">
                <i className="fas fa-tractor"></i>
              </div>
              <h3 className="contact-title">Farm</h3>
              <p className="contact-details">
                SINGAMDODDI VILLAGE SHIVAR<br />
                MIDJIL MANDAL<br />
                MAHABUBNAGAR DIST<br />
                TELANGANA
              </p>
            </div>
            <div className="contact-item">
              <div className="contact-icon">
                <i className="fas fa-envelope"></i>
              </div>
              <h3 className="contact-title">Email</h3>
              <a className="contact-details" href="mailto:contact@gscindiafarms.com">
                contact@gscindiafarms.com
              </a>
            </div>
            <div className="contact-item">
              <div className="contact-icon">
                <i className="fas fa-phone"></i>
              </div>
              <h3 className="contact-title">Phone</h3>
              <a className="contact-details" href="tel:09959925789">
                9959925789
              </a>
            </div>
          </div>
          <div className="footer-bottom">
          <p>&copy; 2026 GSC INDIA Farms and Research Center. All rights reserved.</p>
        </div>
        </section>
      </div>

      {/* Contact Form Popup */}
      {contactFormOpen && (
        <div className="contact-form-overlay" onClick={closeContactForm}>
          <div className="contact-form-container" onClick={(e) => e.stopPropagation()}>
            <button className="contact-form-close" onClick={closeContactForm}>
              <i className="fas fa-times"></i>
            </button>
            
            <h2 className="contact-form-title">Contact Us</h2>
            
            <form className="contact-form" onSubmit={handleContactSubmit}>
              <div className="form-group">
                <label className="form-label" htmlFor="name">Name</label>
                <input 
                  type="text" 
                  id="name" 
                  className="form-input" 
                  required 
                  placeholder="Your Name"
                />
              </div>
              
              <div className="form-group">
                <label className="form-label" htmlFor="phone">Phone Number</label>
                <input 
                  type="tel" 
                  id="phone" 
                  className="form-input" 
                  required 
                  placeholder="Your Phone Number"
                />
              </div>
              
              <div className="form-group">
                <label className="form-label" htmlFor="message">Message</label>
                <textarea 
                  id="message" 
                  className="form-textarea" 
                  required 
                  placeholder="Your Message"
                />
              </div>
              
              <button type="submit" className="contact-form-submit">
                Submit
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Image Gallery Popup */}
      {galleryOpen && (
        <div className="gallery-overlay" onClick={closeGallery}>
          <div className="gallery-container" onClick={(e) => e.stopPropagation()}>
            <button className="gallery-close" onClick={closeGallery}>
              <i className="fas fa-times"></i>
            </button>
            
            <button className="gallery-nav gallery-prev" onClick={() => navigateImage('prev')}>
              <i className="fas fa-chevron-left"></i>
            </button>
            
            <div className="gallery-image-container">
              <img 
                src={aboutImages[currentImageIndex].src} 
                alt={aboutImages[currentImageIndex].alt}
                className="gallery-image"
              />
              <div className="gallery-counter">
                {currentImageIndex + 1} / {aboutImages.length}
              </div>
            </div>
            
            <button className="gallery-nav gallery-next" onClick={() => navigateImage('next')}>
              <i className="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      )}

      {/* Scroll to Top Button */}
      <div 
        className={`scroll-top ${showScrollTop ? 'visible' : ''}`}
        onClick={scrollToTop}
      >
        <i className="fas fa-arrow-up"></i>
      </div>
    </div>
  );
}

export default App;
